import {AdditionalParamsInterface} from "../../interfaces/product/AdditionalParamsInterface";
import {Swiper, SwiperSlide} from "swiper/react";
import {FreeMode, Navigation, Pagination, Thumbs} from "swiper/modules";
import {useState} from "react";
import type {Swiper as SwiperType} from "swiper";
import {Modal} from "react-bootstrap";
import ImageMagnifier from "./ImageMagnifier";
import {getPlaceholderPhotoSrc} from "../../utils/stockLabel";

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';


export default function Photo({additionalParams, productName, hasStock = true}: {
    additionalParams: AdditionalParamsInterface,
    productName?: string,
    hasStock?: boolean
}) {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [modalThumbsSwiper, setModalThumbsSwiper] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);
    const [activeModalIndex, setActiveModalIndex] = useState<number>(0);

    const getPhotos = (size: string) => {
        let photos: string[] = [];
        [...(additionalParams?.images?.zoom || [])].sort((a, b) => a.localeCompare(b, undefined, { numeric: true })).forEach(image => {
            photos.push('https://www.pride.ru' + image.replace(/catalog-source\//, `catalog-resize/${size}x${size}/`))
        });
        [...(additionalParams?.images?.photo || [])].sort((a, b) => a.localeCompare(b, undefined, { numeric: true })).forEach(image => {
            photos.push('https://www.pride.ru' + image.replace(/catalog-source\//, `catalog-resize/${size}x${size}/`))
        });
        return photos;
    }

    const handleImageClick = (index: number) => {
        setSelectedImageIndex(index);
        setActiveModalIndex(index);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setModalThumbsSwiper(null);
    };

    return (<div className="d-flex col-12 col-md-5 flex-column-reverse flex-md-row left-product product__left">
        <div className="left-product__thumbs">
            <div className="left-product__slider-min">
                <Swiper
                    onSwiper={setThumbsSwiper}
                    spaceBetween={6}
                    slidesPerView={4}
                    width={400}
                    updateOnImagesReady={true}
                    observer={true}
                    observeParents={true}
                    watchSlidesProgress={true}
                    watchSlidesVisibility={true}
                    modules={[Pagination, Navigation, Thumbs]}
                    breakpoints={
                        {
                            768: {
                                direction: 'vertical',
                                slidesPerView: 4,
                                spaceBetween: 10,
                                height: 450,
                                updateOnImagesReady: true,
                                observer: true,
                                observeParents: true,
                                watchSlidesProgress: true,
                                watchSlidesVisibility: true,

                            }
                        }
                    }
                >
                    {getPhotos('200').map(photo => <SwiperSlide key={photo}>
                        <img src={photo} alt="Product thumbnail"/>
                    </SwiperSlide>)}
                </Swiper>
            </div>
        </div>
        {getPhotos('1000').length > 0 ? <div className="left-product__slider-big">
            <Swiper
                style={{
                    '--swiper-navigation-color': '#ff5722',
                    '--swiper-pagination-color': '#ff5722',
                }}
                spaceBetween={10}
                navigation={true}
                thumbs={{swiper: thumbsSwiper}}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper2"
            >
                {getPhotos('1000').map((photo, index) => <SwiperSlide key={photo}>
                    <img
                        src={photo}
                        alt="Product view"
                        style={{cursor: 'pointer'}}
                        onClick={() => handleImageClick(index)}
                    />
                </SwiperSlide>)}
            </Swiper>
        </div> : <div className="left-product__slider-big"><img src={getPlaceholderPhotoSrc(hasStock)} className={'w-100'} alt={hasStock ? 'Нет фото' : 'Скоро в продаже'}/></div>}

        <Modal show={showModal} onHide={handleCloseModal} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>{productName || 'Product Image'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {showModal && (
                    <div className="d-flex flex-column-reverse flex-md-row gap-3" key={selectedImageIndex}>
                        <div className="modal-thumbs-container">
                            <Swiper
                                onSwiper={setModalThumbsSwiper}
                                spaceBetween={6}
                                slidesPerView={4}
                                freeMode={true}
                                watchSlidesProgress={true}
                                modules={[FreeMode, Navigation, Thumbs]}
                                className="modal-thumbs-swiper"
                                breakpoints={{
                                    768: {
                                        direction: 'vertical',
                                        slidesPerView: 4,
                                        spaceBetween: 10,
                                        height: 500
                                    }
                                }}
                            >
                                {getPhotos('1000').map((photo, index) => (
                                    <SwiperSlide key={`thumb-${index}`} style={{cursor: 'pointer'}}>
                                        <img
                                            src={photo.replace('1000x1000', '200x200')}
                                            alt={`Thumbnail ${index + 1}`}
                                            style={{width: '100%', height: '100%', objectFit: 'contain'}}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                        <div className="modal-main-image">
                            <Swiper
                                style={{
                                    '--swiper-navigation-color': '#ff5722',
                                    '--swiper-pagination-color': '#ff5722',
                                }}
                                spaceBetween={10}
                                navigation={true}
                                thumbs={{swiper: modalThumbsSwiper}}
                                modules={[FreeMode, Navigation, Thumbs]}
                                initialSlide={selectedImageIndex}
                                watchSlidesProgress={true}
                                simulateTouch={false}
                                onSlideChange={(swiper: SwiperType) => setActiveModalIndex(swiper.activeIndex)}
                                className="modal-main-swiper"
                            >
                                {getPhotos('1000').map((photo, index) => (
                                    <SwiperSlide key={`main-${index}`}>
                                        <ImageMagnifier
                                            src={photo}
                                            zoomSrc={photo.replace('1000x1000', '2000x2000')}
                                            alt={`Product view ${index + 1}`}
                                            enabled={index === activeModalIndex}
                                        />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    </div>)
}